import { render, staticRenderFns } from "./BillDeleteHistory.vue?vue&type=template&id=31af5472"
import script from "./BillDeleteHistory.vue?vue&type=script&lang=js"
export * from "./BillDeleteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports